export type Language = 'pt' | 'fr' | 'en';

export const translations: Record<Language, Record<string, string>> = {
  pt: {
    // Nav
    'nav.home': 'Início',
    'nav.services': 'Serviços',
    'nav.partners': 'Parceiros',
    'nav.hosting': 'Hosting',
    'nav.contact': 'Contacto',
    'nav.login': 'Entrar',
    'nav.register': 'Registar',
    'nav.portal': 'Portal do Cliente',
    'nav.admin': 'Administração',
    'nav.logout': 'Sair',
    'nav.quote': 'Solicitar Cotação',
    'nav.about': 'Sobre Nós',
    'nav.industries': 'Indústrias',

    // Hero slides
    'hero.slide1.title': 'Licenças Microsoft',
    'hero.slide1.subtitle': 'Office 365, Windows, Azure, Server — soluções completas para a sua empresa.',
    'hero.slide2.title': 'Soluções Adobe',
    'hero.slide2.subtitle': 'Creative Cloud, Acrobat e mais — ferramentas criativas para cada projecto.',
    'hero.slide3.title': 'Segurança Cibernética',
    'hero.slide3.subtitle': 'Kaspersky, 3CX, Ekahau — protecção e comunicação de nível empresarial.',
    'hero.slide4.title': 'Procurement Industrial',
    'hero.slide4.subtitle': 'Material industrial, peças petrolíferas e tecnológicas — sourcing global.',
    'hero.cta': 'Solicitar Cotação',
    'hero.explore': 'Explorar Serviços',

    // Quick Nav
    'quicknav.title': 'O que procura?',
    'quicknav.subtitle': 'Selecione o serviço que melhor atende às suas necessidades',
    'quicknav.licenses': 'Licenças',
    'quicknav.licenses_desc': 'Microsoft, Adobe, Kaspersky, 3CX, Ekahau',
    'quicknav.support': 'Suporte Técnico',
    'quicknav.support_desc': 'Assistência especializada para todos os produtos',
    'quicknav.procurement': 'Procurement & Sourcing',
    'quicknav.procurement_desc': 'Material industrial, peças petrolíferas e tecnológicas',
    'quicknav.hosting': 'Apps & Web Hosting',
    'quicknav.hosting_desc': 'Desenvolvimento de aplicações e hospedagem web',

    // Services
    'services.title': 'Nossos Serviços',
    'services.subtitle': 'Soluções completas para a sua empresa',
    'services.licenses.title': 'Venda de Licenças',
    'services.licenses.desc': 'Licenças oficiais Microsoft, Adobe, 3CX, Kaspersky e Ekahau com suporte completo.',
    'services.support.title': 'Suporte Técnico',
    'services.support.desc': 'Suporte especializado para produtos Microsoft, Adobe, 3CX, Kaspersky e Ekahau.',
    'services.procurement.title': 'Procurement & Sourcing',
    'services.procurement.desc': 'Material industrial, peças petrolíferas e peças tecnológicas.',
    'services.hosting.title': 'Web Hosting',
    'services.hosting.desc': 'Serviço de hosting profissional disponível em maluzhosting.org.',

    // Industries
    'industries.title': 'Indústrias que Servimos',
    'industries.subtitle': 'Soluções adaptadas a cada sector',
    'industries.health': 'Saúde',
    'industries.health_desc': 'Soluções tecnológicas para hospitais, clínicas e laboratórios.',
    'industries.consulting': 'Consultoria',
    'industries.consulting_desc': 'Ferramentas digitais para empresas de consultoria e auditoria.',
    'industries.banks': 'Bancos & Finanças',
    'industries.banks_desc': 'Segurança, infraestrutura e licenças para o sector financeiro.',
    'industries.manufacturing': 'Manufactura',
    'industries.manufacturing_desc': 'Equipamentos e software para a indústria manufactureira.',
    'industries.education': 'Educação',
    'industries.education_desc': 'Licenças académicas e soluções para instituições de ensino.',
    'industries.petroleum': 'Indústria Petrolífera',
    'industries.petroleum_desc': 'Peças, equipamentos e software para o sector petrolífero.',

    // About
    'about.title': 'Sobre Nós',
    'about.subtitle': 'Conheça as Nossas Competências',
    'about.intro': 'Somos uma empresa provedora de soluções tecnológicas. Oferecemos soluções eficientes que apoiam todo tipo de negócio.',
    'about.desc': 'Quer sua empresa seja uma startup em crescimento ou uma empresa estabelecida, nossas soluções personalizadas e habilidades contemporâneas oferecem resultados.',
    'about.experience': 'Anos de Experiência',
    'about.clients': 'Clientes Globais',
    'about.professionalism': 'Profissionalismo',
    'about.professionalism_desc': 'Temos um profundo conhecimento do que fazemos e estamos continuamente a melhorar as nossas capacidades.',
    'about.creativity': 'Criatividade',
    'about.creativity_desc': 'O que nos distingue é a paixão do que fazemos — o principal impulsionador das nossas acções.',
    'about.customer_value': 'Valor ao Cliente',
    'about.customer_value_desc': 'A satisfação dos nossos clientes é o ponto focal das nossas actividades.',
    'about.org': 'A MALUZ Technologies está actualmente operando em Angola e planeia fazer parte do conselho internacional. Conhecimento, inovação técnica e trabalho em equipa são o nosso centro de gravidade.',

    // Partners
    'partners.title': 'Nossos Parceiros',
    'partners.subtitle': 'Trabalhamos com as melhores marcas do mercado',

    // Quote
    'quote.title': 'Solicitar Cotação',
    'quote.subtitle': 'Preencha o formulário abaixo para receber uma cotação personalizada',
    'quote.category': 'Categoria do Produto',
    'quote.product': 'Produto',
    'quote.quantity': 'Quantidade',
    'quote.details': 'Detalhes Adicionais',
    'quote.email': 'Email de Contacto',
    'quote.phone': 'Telefone',
    'quote.company': 'Nome da Empresa',
    'quote.submit': 'Enviar Pedido',
    'quote.success': 'Cotação enviada com sucesso!',
    'quote.select_category': 'Selecione uma categoria',
    'quote.select_product': 'Selecione um produto',

    // Categories
    'cat.licenses': 'Licenças de Software',
    'cat.support': 'Suporte Técnico',
    'cat.procurement': 'Procurement & Sourcing',
    'cat.hosting': 'Web Hosting',

    // Contact
    'contact.title': 'Contacte-nos',
    'contact.subtitle': 'Estamos aqui para ajudar',
    'contact.name': 'Nome',
    'contact.email': 'Email',
    'contact.subject': 'Assunto',
    'contact.message': 'Mensagem',
    'contact.send': 'Enviar Mensagem',
    'contact.success': 'Mensagem enviada com sucesso!',
    'contact.address': 'Endereço',
    'contact.phone': 'Telefone',

    // Auth
    'auth.login': 'Entrar',
    'auth.register': 'Criar Conta',
    'auth.email': 'Email',
    'auth.password': 'Palavra-passe',
    'auth.name': 'Nome Completo',
    'auth.company': 'Empresa',
    'auth.phone': 'Telefone',
    'auth.no_account': 'Não tem conta?',
    'auth.has_account': 'Já tem conta?',
    'auth.forgot_password': 'Esqueceu a palavra-passe?',

    // Portal
    'portal.dashboard': 'Painel',
    'portal.quotes': 'Cotações',
    'portal.invoices': 'Facturas',
    'portal.licenses': 'Licenças',
    'portal.welcome': 'Bem-vindo',
    'portal.no_quotes': 'Nenhuma cotação encontrada',
    'portal.no_invoices': 'Nenhuma factura encontrada',
    'portal.no_licenses': 'Nenhuma licença encontrada',
    'portal.new_quote': 'Nova Cotação',
    'portal.status': 'Estado',
    'portal.date': 'Data',
    'portal.product': 'Produto',
    'portal.amount': 'Valor',
    'portal.actions': 'Acções',

    // Admin
    'admin.dashboard': 'Painel Admin',
    'admin.users': 'Utilizadores',
    'admin.quotes': 'Cotações',
    'admin.invoices': 'Facturas',
    'admin.licenses': 'Licenças',
    'admin.contacts': 'Mensagens',
    'admin.total_users': 'Total Utilizadores',
    'admin.total_quotes': 'Total Cotações',
    'admin.pending_quotes': 'Cotações Pendentes',
    'admin.total_invoices': 'Total Facturas',
    'admin.total_licenses': 'Total Licenças',
    'admin.total_contacts': 'Total Mensagens',

    // Status
    'status.pending': 'Pendente',
    'status.approved': 'Aprovado',
    'status.rejected': 'Rejeitado',
    'status.active': 'Activo',
    'status.expired': 'Expirado',
    'status.paid': 'Pago',
    'status.unpaid': 'Não Pago',
    'status.new': 'Novo',

    // Footer
    'footer.rights': 'Todos os direitos reservados.',
    'footer.description': 'Fornecedor líder de soluções tecnológicas e industriais em Angola.',

    // CTA
    'cta.partnership': 'À procura de parceria?',
    'cta.partnership_desc': 'Trabalhamos com líderes de ecossistemas, empresas e startups em todo o mundo.',
    'cta.contact_us': 'Contacte-nos',

    // Marketplace
    'mp.title': 'MARKETPLACE DE LICENÇAS',
    'mp.products_available': 'produtos disponíveis',
    'mp.search': 'Pesquisar...',
    'mp.cart': 'Carrinho',
    'mp.add_to_quote': 'Adicionar ao Pedido',
    'mp.quote_cart': 'Carrinho de Cotação',
    'mp.empty_cart': 'O seu carrinho está vazio',
    'mp.contact_email': 'Email de Contacto',
    'mp.request_quote': 'Solicitar Cotação',
    'mp.download_pdf': 'Descarregar PDF da Cotação',
    'mp.continue_shopping': 'Continuar a Comprar',
    'mp.items': 'itens',

    // Chat
    'chat.start': 'Iniciar Conversa',
    'chat.your_name': 'Seu nome',
    'chat.email_optional': 'Email (opcional)',
    'chat.type_message': 'Escreva uma mensagem...',
    'chat.start_btn': 'Iniciar Chat',
  },

  fr: {
    'nav.home': 'Accueil',
    'nav.services': 'Services',
    'nav.partners': 'Partenaires',
    'nav.hosting': 'Hébergement',
    'nav.contact': 'Contact',
    'nav.login': 'Connexion',
    'nav.register': "S'inscrire",
    'nav.portal': 'Espace Client',
    'nav.admin': 'Administration',
    'nav.logout': 'Déconnexion',
    'nav.quote': 'Demander un Devis',
    'nav.about': 'À Propos',
    'nav.industries': 'Industries',

    'hero.slide1.title': 'Licences Microsoft',
    'hero.slide1.subtitle': 'Office 365, Windows, Azure, Server — solutions complètes pour votre entreprise.',
    'hero.slide2.title': 'Solutions Adobe',
    'hero.slide2.subtitle': 'Creative Cloud, Acrobat et plus — outils créatifs pour chaque projet.',
    'hero.slide3.title': 'Cybersécurité',
    'hero.slide3.subtitle': 'Kaspersky, 3CX, Ekahau — protection et communication entreprise.',
    'hero.slide4.title': 'Procurement Industriel',
    'hero.slide4.subtitle': 'Matériel industriel, pièces pétrolières et technologiques — sourcing global.',
    'hero.cta': 'Demander un Devis',
    'hero.explore': 'Explorer les Services',

    'quicknav.title': 'Que recherchez-vous?',
    'quicknav.subtitle': 'Sélectionnez le service qui répond à vos besoins',
    'quicknav.licenses': 'Licences',
    'quicknav.licenses_desc': 'Microsoft, Adobe, Kaspersky, 3CX, Ekahau',
    'quicknav.support': 'Support Technique',
    'quicknav.support_desc': 'Assistance spécialisée pour tous les produits',
    'quicknav.procurement': 'Procurement & Sourcing',
    'quicknav.procurement_desc': 'Matériel industriel, pièces pétrolières et technologiques',
    'quicknav.hosting': 'Apps & Hébergement Web',
    'quicknav.hosting_desc': "Développement d'applications et hébergement web",

    'services.title': 'Nos Services',
    'services.subtitle': 'Des solutions complètes pour votre entreprise',
    'services.licenses.title': 'Vente de Licences',
    'services.licenses.desc': 'Licences officielles Microsoft, Adobe, 3CX, Kaspersky et Ekahau avec support complet.',
    'services.support.title': 'Support Technique',
    'services.support.desc': 'Support spécialisé pour les produits Microsoft, Adobe, 3CX, Kaspersky et Ekahau.',
    'services.procurement.title': 'Procurement & Sourcing',
    'services.procurement.desc': 'Matériel industriel, pièces pétrolières et pièces technologiques.',
    'services.hosting.title': 'Hébergement Web',
    'services.hosting.desc': "Service d'hébergement professionnel disponible sur maluzhosting.org.",

    'industries.title': 'Industries que Nous Servons',
    'industries.subtitle': 'Solutions adaptées à chaque secteur',
    'industries.health': 'Santé',
    'industries.health_desc': 'Solutions technologiques pour hôpitaux, cliniques et laboratoires.',
    'industries.consulting': 'Conseil',
    'industries.consulting_desc': "Outils numériques pour les cabinets de conseil et d'audit.",
    'industries.banks': 'Banques & Finance',
    'industries.banks_desc': 'Sécurité, infrastructure et licences pour le secteur financier.',
    'industries.manufacturing': 'Manufacture',
    'industries.manufacturing_desc': "Équipements et logiciels pour l'industrie manufacturière.",
    'industries.education': 'Éducation',
    'industries.education_desc': "Licences académiques et solutions pour les établissements d'enseignement.",
    'industries.petroleum': 'Industrie Pétrolière',
    'industries.petroleum_desc': 'Pièces, équipements et logiciels pour le secteur pétrolier.',

    'about.title': 'À Propos de Nous',
    'about.subtitle': 'Découvrez nos Compétences',
    'about.intro': 'Nous sommes une entreprise fournisseur de solutions technologiques. Nous offrons des solutions efficaces qui soutiennent tout type de business.',
    'about.desc': "Que votre entreprise soit une startup en croissance ou une entreprise établie, nos solutions personnalisées offrent des résultats.",
    'about.experience': "Années d'Expérience",
    'about.clients': 'Clients Mondiaux',
    'about.professionalism': 'Professionnalisme',
    'about.professionalism_desc': "Nous avons une connaissance approfondie de ce que nous faisons et nous améliorons continuellement nos capacités.",
    'about.creativity': 'Créativité',
    'about.creativity_desc': "Ce qui nous distingue est la passion de ce que nous faisons — le principal moteur de nos actions.",
    'about.customer_value': 'Valeur Client',
    'about.customer_value_desc': 'La satisfaction de nos clients est le point focal de nos activités.',
    'about.org': "MALUZ Technologies opère actuellement en Angola et prévoit de rejoindre le conseil international. Connaissance, innovation technique et travail d'équipe sont notre centre de gravité.",

    'partners.title': 'Nos Partenaires',
    'partners.subtitle': 'Nous travaillons avec les meilleures marques du marché',

    'quote.title': 'Demander un Devis',
    'quote.subtitle': 'Remplissez le formulaire ci-dessous pour recevoir un devis personnalisé',
    'quote.category': 'Catégorie du Produit',
    'quote.product': 'Produit',
    'quote.quantity': 'Quantité',
    'quote.details': 'Détails Supplémentaires',
    'quote.email': 'Email de Contact',
    'quote.phone': 'Téléphone',
    'quote.company': "Nom de l'Entreprise",
    'quote.submit': 'Envoyer la Demande',
    'quote.success': 'Devis envoyé avec succès!',
    'quote.select_category': 'Sélectionnez une catégorie',
    'quote.select_product': 'Sélectionnez un produit',

    'cat.licenses': 'Licences Logicielles',
    'cat.support': 'Support Technique',
    'cat.procurement': 'Procurement & Sourcing',
    'cat.hosting': 'Hébergement Web',

    'contact.title': 'Contactez-nous',
    'contact.subtitle': 'Nous sommes là pour vous aider',
    'contact.name': 'Nom',
    'contact.email': 'Email',
    'contact.subject': 'Sujet',
    'contact.message': 'Message',
    'contact.send': 'Envoyer le Message',
    'contact.success': 'Message envoyé avec succès!',
    'contact.address': 'Adresse',
    'contact.phone': 'Téléphone',

    'auth.login': 'Connexion',
    'auth.register': 'Créer un Compte',
    'auth.email': 'Email',
    'auth.password': 'Mot de passe',
    'auth.name': 'Nom Complet',
    'auth.company': 'Entreprise',
    'auth.phone': 'Téléphone',
    'auth.no_account': "Pas de compte?",
    'auth.has_account': 'Déjà un compte?',
    'auth.forgot_password': 'Mot de passe oublié?',

    'portal.dashboard': 'Tableau de Bord',
    'portal.quotes': 'Devis',
    'portal.invoices': 'Factures',
    'portal.licenses': 'Licences',
    'portal.welcome': 'Bienvenue',
    'portal.no_quotes': 'Aucun devis trouvé',
    'portal.no_invoices': 'Aucune facture trouvée',
    'portal.no_licenses': 'Aucune licence trouvée',
    'portal.new_quote': 'Nouveau Devis',
    'portal.status': 'Statut',
    'portal.date': 'Date',
    'portal.product': 'Produit',
    'portal.amount': 'Montant',
    'portal.actions': 'Actions',

    'admin.dashboard': 'Panneau Admin',
    'admin.users': 'Utilisateurs',
    'admin.quotes': 'Devis',
    'admin.invoices': 'Factures',
    'admin.licenses': 'Licences',
    'admin.contacts': 'Messages',
    'admin.total_users': 'Total Utilisateurs',
    'admin.total_quotes': 'Total Devis',
    'admin.pending_quotes': 'Devis en Attente',
    'admin.total_invoices': 'Total Factures',
    'admin.total_licenses': 'Total Licences',
    'admin.total_contacts': 'Total Messages',

    'status.pending': 'En Attente',
    'status.approved': 'Approuvé',
    'status.rejected': 'Rejeté',
    'status.active': 'Actif',
    'status.expired': 'Expiré',
    'status.paid': 'Payé',
    'status.unpaid': 'Non Payé',
    'status.new': 'Nouveau',

    'footer.rights': 'Tous droits réservés.',
    'footer.description': "Fournisseur leader de solutions technologiques et industrielles en Angola.",

    'cta.partnership': 'Recherchez-vous un partenariat?',
    'cta.partnership_desc': "Nous travaillons avec des leaders d'écosystèmes, des entreprises et des startups dans le monde entier.",
    'cta.contact_us': 'Contactez-nous',

    'mp.title': 'MARKETPLACE DE LICENCES',
    'mp.products_available': 'produits disponibles',
    'mp.search': 'Rechercher...',
    'mp.cart': 'Panier',
    'mp.add_to_quote': 'Ajouter au Devis',
    'mp.quote_cart': 'Panier de Devis',
    'mp.empty_cart': 'Votre panier est vide',
    'mp.contact_email': 'Email de Contact',
    'mp.request_quote': 'Demander un Devis',
    'mp.download_pdf': 'Télécharger le PDF du Devis',
    'mp.continue_shopping': 'Continuer les Achats',
    'mp.items': 'articles',

    'chat.start': 'Démarrer une Conversation',
    'chat.your_name': 'Votre nom',
    'chat.email_optional': 'Email (optionnel)',
    'chat.type_message': 'Tapez un message...',
    'chat.start_btn': 'Démarrer le Chat',
  },

  en: {
    'nav.home': 'Home',
    'nav.services': 'Services',
    'nav.partners': 'Partners',
    'nav.hosting': 'Hosting',
    'nav.contact': 'Contact',
    'nav.login': 'Login',
    'nav.register': 'Register',
    'nav.portal': 'Client Portal',
    'nav.admin': 'Admin',
    'nav.logout': 'Logout',
    'nav.quote': 'Request Quote',
    'nav.about': 'About Us',
    'nav.industries': 'Industries',

    'hero.slide1.title': 'Microsoft Licenses',
    'hero.slide1.subtitle': 'Office 365, Windows, Azure, Server — complete solutions for your business.',
    'hero.slide2.title': 'Adobe Solutions',
    'hero.slide2.subtitle': 'Creative Cloud, Acrobat and more — creative tools for every project.',
    'hero.slide3.title': 'Cybersecurity',
    'hero.slide3.subtitle': 'Kaspersky, 3CX, Ekahau — enterprise-grade protection and communication.',
    'hero.slide4.title': 'Industrial Procurement',
    'hero.slide4.subtitle': 'Industrial equipment, petroleum parts and tech parts — global sourcing.',
    'hero.cta': 'Request a Quote',
    'hero.explore': 'Explore Services',

    'quicknav.title': 'What are you looking for?',
    'quicknav.subtitle': 'Select the service that best meets your needs',
    'quicknav.licenses': 'Licenses',
    'quicknav.licenses_desc': 'Microsoft, Adobe, Kaspersky, 3CX, Ekahau',
    'quicknav.support': 'Technical Support',
    'quicknav.support_desc': 'Specialized assistance for all products',
    'quicknav.procurement': 'Procurement & Sourcing',
    'quicknav.procurement_desc': 'Industrial equipment, petroleum and tech parts',
    'quicknav.hosting': 'Apps & Web Hosting',
    'quicknav.hosting_desc': 'Application development and web hosting',

    'services.title': 'Our Services',
    'services.subtitle': 'Complete solutions for your business',
    'services.licenses.title': 'License Sales',
    'services.licenses.desc': 'Official Microsoft, Adobe, 3CX, Kaspersky and Ekahau licenses with full support.',
    'services.support.title': 'Technical Support',
    'services.support.desc': 'Specialized support for Microsoft, Adobe, 3CX, Kaspersky and Ekahau products.',
    'services.procurement.title': 'Procurement & Sourcing',
    'services.procurement.desc': 'Industrial equipment, petroleum parts and technology parts.',
    'services.hosting.title': 'Web Hosting',
    'services.hosting.desc': 'Professional hosting service available at maluzhosting.org.',

    'industries.title': 'Industries We Serve',
    'industries.subtitle': 'Solutions adapted to each sector',
    'industries.health': 'Healthcare',
    'industries.health_desc': 'Technology solutions for hospitals, clinics and laboratories.',
    'industries.consulting': 'Consulting',
    'industries.consulting_desc': 'Digital tools for consulting and audit firms.',
    'industries.banks': 'Banks & Finance',
    'industries.banks_desc': 'Security, infrastructure and licenses for the financial sector.',
    'industries.manufacturing': 'Manufacturing',
    'industries.manufacturing_desc': 'Equipment and software for the manufacturing industry.',
    'industries.education': 'Education',
    'industries.education_desc': 'Academic licenses and solutions for educational institutions.',
    'industries.petroleum': 'Petroleum Industry',
    'industries.petroleum_desc': 'Parts, equipment and software for the oil and gas sector.',

    'about.title': 'About Us',
    'about.subtitle': 'Discover Our Competencies',
    'about.intro': 'We are a technology solutions provider company. We offer efficient solutions that support all types of business.',
    'about.desc': 'Whether your company is a growing startup or an established enterprise, our customized solutions and contemporary skills deliver results.',
    'about.experience': 'Years of Experience',
    'about.clients': 'Global Clients',
    'about.professionalism': 'Professionalism',
    'about.professionalism_desc': 'We have deep knowledge of what we do and are continuously improving our capabilities.',
    'about.creativity': 'Creativity',
    'about.creativity_desc': 'What sets us apart is the passion for what we do — the main driver of our actions.',
    'about.customer_value': 'Customer Value',
    'about.customer_value_desc': 'Customer satisfaction is the focal point of our activities.',
    'about.org': 'MALUZ Technologies is currently operating in Angola and plans to join the international arena. Knowledge, technical innovation and teamwork are our center of gravity.',

    'partners.title': 'Our Partners',
    'partners.subtitle': 'We work with the best brands in the market',

    'quote.title': 'Request a Quote',
    'quote.subtitle': 'Fill out the form below to receive a personalized quote',
    'quote.category': 'Product Category',
    'quote.product': 'Product',
    'quote.quantity': 'Quantity',
    'quote.details': 'Additional Details',
    'quote.email': 'Contact Email',
    'quote.phone': 'Phone',
    'quote.company': 'Company Name',
    'quote.submit': 'Submit Request',
    'quote.success': 'Quote request submitted successfully!',
    'quote.select_category': 'Select a category',
    'quote.select_product': 'Select a product',

    'cat.licenses': 'Software Licenses',
    'cat.support': 'Technical Support',
    'cat.procurement': 'Procurement & Sourcing',
    'cat.hosting': 'Web Hosting',

    'contact.title': 'Contact Us',
    'contact.subtitle': 'We are here to help',
    'contact.name': 'Name',
    'contact.email': 'Email',
    'contact.subject': 'Subject',
    'contact.message': 'Message',
    'contact.send': 'Send Message',
    'contact.success': 'Message sent successfully!',
    'contact.address': 'Address',
    'contact.phone': 'Phone',

    'auth.login': 'Login',
    'auth.register': 'Create Account',
    'auth.email': 'Email',
    'auth.password': 'Password',
    'auth.name': 'Full Name',
    'auth.company': 'Company',
    'auth.phone': 'Phone',
    'auth.no_account': "Don't have an account?",
    'auth.has_account': 'Already have an account?',
    'auth.forgot_password': 'Forgot password?',

    'portal.dashboard': 'Dashboard',
    'portal.quotes': 'Quotes',
    'portal.invoices': 'Invoices',
    'portal.licenses': 'Licenses',
    'portal.welcome': 'Welcome',
    'portal.no_quotes': 'No quotes found',
    'portal.no_invoices': 'No invoices found',
    'portal.no_licenses': 'No licenses found',
    'portal.new_quote': 'New Quote',
    'portal.status': 'Status',
    'portal.date': 'Date',
    'portal.product': 'Product',
    'portal.amount': 'Amount',
    'portal.actions': 'Actions',

    'admin.dashboard': 'Admin Dashboard',
    'admin.users': 'Users',
    'admin.quotes': 'Quotes',
    'admin.invoices': 'Invoices',
    'admin.licenses': 'Licenses',
    'admin.contacts': 'Messages',
    'admin.total_users': 'Total Users',
    'admin.total_quotes': 'Total Quotes',
    'admin.pending_quotes': 'Pending Quotes',
    'admin.total_invoices': 'Total Invoices',
    'admin.total_licenses': 'Total Licenses',
    'admin.total_contacts': 'Total Messages',

    'status.pending': 'Pending',
    'status.approved': 'Approved',
    'status.rejected': 'Rejected',
    'status.active': 'Active',
    'status.expired': 'Expired',
    'status.paid': 'Paid',
    'status.unpaid': 'Unpaid',
    'status.new': 'New',

    'footer.rights': 'All rights reserved.',
    'footer.description': 'Leading provider of technology and industrial solutions in Angola.',

    'cta.partnership': 'Looking for a partnership?',
    'cta.partnership_desc': 'We work with ecosystem leaders, companies and startups worldwide.',
    'cta.contact_us': 'Contact Us',

    'mp.title': 'LICENSES MARKETPLACE',
    'mp.products_available': 'products available',
    'mp.search': 'Search...',
    'mp.cart': 'Cart',
    'mp.add_to_quote': 'Add to Quote',
    'mp.quote_cart': 'Quote Cart',
    'mp.empty_cart': 'Your cart is empty',
    'mp.contact_email': 'Contact Email',
    'mp.request_quote': 'Request Quote',
    'mp.download_pdf': 'Download Quote PDF',
    'mp.continue_shopping': 'Continue Shopping',
    'mp.items': 'items',

    'chat.start': 'Start a Conversation',
    'chat.your_name': 'Your name',
    'chat.email_optional': 'Email (optional)',
    'chat.type_message': 'Type a message...',
    'chat.start_btn': 'Start Chat',
  }
};
